import type { CSSProperties, ReactElement } from 'react';

type ZoomableImageCursorProps = {
  children: ReactElement;
  enabled: boolean;
  isZoomedIn: boolean;
};

export function getZoomCursor(isZoomedIn: boolean): CSSProperties['cursor'] {
  return isZoomedIn ? 'zoom-out' : 'zoom-in';
}

export default function ZoomableImageCursor({
  children,
  enabled,
  isZoomedIn,
}: ZoomableImageCursorProps) {
  if (!enabled) {
    return children;
  }

  const style: CSSProperties = {
    cursor: getZoomCursor(isZoomedIn),
    display: 'contents',
  };

  return <div style={style}>{children}</div>;
}
